import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { closeCallMeModal, closeContactModal, useModal } from 'src/common';
import { CallMeModal, ContactModal, Content, Footer, Header, Message } from 'src/components';


export const AppRouter = () => {
  const { pathname } = useLocation();
  const { callMeModal, contactModal } = useModal();
  const [headerExpanded, setHeaderExpanded] = useState<boolean | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Header expanded={headerExpanded} onExpandedChange={setHeaderExpanded} />
      <Content expanded={headerExpanded}>
        <Message />
        <Outlet />
      </Content>
      <Footer />

      <CallMeModal open={callMeModal} onClose={() => closeCallMeModal()} />
      <ContactModal open={contactModal} onClose={() => closeContactModal()} />
    </>
  )
};
